import { Component, inject } from '@angular/core';
import {
  DynamicFormField,
  fieldGroup,
  formBuilder,
  select,
  selectLazy,
} from '@kinet-open-network/client/core/forms/ui';
import { TagsService } from '@kinet-open-network/client/tags/data-access';
import {
  AutomationRuleOperator,
  IAutomationRule,
} from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';
import { RuleComponent } from './abstract-rule.component';

@Component({
  selector: 'kon-tag-rule',
  imports: [FormlyModule],
  template: ` <formly-form
    [fields]="fields"
    [model]="model"
    (modelChange)="handleModelChange($event)"
  />`,
})
export class TagRuleComponent extends RuleComponent {
  readonly #tagService = inject(TagsService);

  override defaultModel: Partial<IAutomationRule> = {
    operator: AutomationRuleOperator.Equals,
  };

  override fields: DynamicFormField[] = formBuilder(
    fieldGroup()
      .fieldGroupClassName(`grid grid-cols-3 gap-2`)
      .fieldGroup([
        this.ruleSelectField,
        select('operator', '')
          .options([
            {
              label: 'je',
              value: AutomationRuleOperator.Equals,
            },
            {
              label: 'nie je',
              value: AutomationRuleOperator.NotEquals,
            },
          ])
          .wrappers([]),
        selectLazy('value', '', 'label', 'id')
          .query(this.#tagService)
          .wrappers([]),
      ]),
  );
}
